import type { LanguageCode } from '../types'

const en = {
    showPassword: 'Show password',
    hidePassword: 'Hide password',
    lightTheme: 'Use light theme',
    darkTheme: 'Use dark theme',
    loading: 'Loading…',
    creatingAccount: 'Creating account…',
    sending: 'Sending…',
    saving: 'Saving…',
    firstNameRequired: 'Enter your first name.',
    lastNameRequired: 'Enter your last name.',
    connectionError: 'Check your connection and try again.',
    loginFailed: 'Couldn’t log in. Please try again.',
    locked: 'Too many attempts. Wait a few minutes and try again.',
    passwordGuide: 'Use 8 or more characters, an uppercase letter, a number, and a symbol such as ! or @.',
}

export const authCopy: Record<LanguageCode, typeof en> = {
    en,
    ha: {
        showPassword: 'Nuna password',
        hidePassword: 'Ɓoye password',
        lightTheme: 'Yi amfani da haske',
        darkTheme: 'Yi amfani da duhu',
        loading: 'Ana lodawa…',
        creatingAccount: 'Ana buɗe asusu…',
        sending: 'Ana aikawa…',
        saving: 'Ana adanawa…',
        firstNameRequired: 'Ku rubuta sunanku na farko.',
        lastNameRequired: 'Ku rubuta sunan iyalinku.',
        connectionError: 'Ku duba network, ku sake gwadawa.',
        loginFailed: 'Ba a samu shiga ba. Ku sake gwadawa.',
        locked: 'An yi ƙoƙari da yawa. Ku jira mintuna kaɗan, ku sake gwadawa.',
        passwordGuide: 'Haruffa 8 ko fiye, babban harafi, lamba, da alama kamar ! ko @.',
    },
    ar: {
        showPassword: 'إظهار كلمة المرور',
        hidePassword: 'إخفاء كلمة المرور',
        lightTheme: 'استخدام المظهر الفاتح',
        darkTheme: 'استخدام المظهر الداكن',
        loading: 'جارٍ التحميل…',
        creatingAccount: 'جارٍ إنشاء الحساب…',
        sending: 'جارٍ الإرسال…',
        saving: 'جارٍ الحفظ…',
        firstNameRequired: 'يرجى كتابة الاسم الأول.',
        lastNameRequired: 'يرجى كتابة اسم العائلة.',
        connectionError: 'تحقّقوا من الاتصال ثم أعيدوا المحاولة.',
        loginFailed: 'تعذّر تسجيل الدخول. يرجى المحاولة مجددًا.',
        locked: 'محاولات كثيرة. يرجى الانتظار بضع دقائق ثم المحاولة مجددًا.',
        passwordGuide: '٨ خانات على الأقل، تشمل حرفًا لاتينيًا كبيرًا ورقمًا ورمزًا مثل ! أو @.',
    },
}

// Keep error keys in form state so a language change also updates visible errors.
export function authMessage(language: LanguageCode, key: string, t: (key: string) => string): string {
    if (!key) return ''
    return Object.hasOwn(authCopy[language], key) ? authCopy[language][key as keyof typeof en] : t(key)
}
